import React from 'react';
import PropTypes from 'prop-types';

// Mixins / Modules
import { isEmptyObject } from '../../../../../../modules/global';

// Models
import Department from '../../../../../../models/v2/department';

// Base
import Badge from '../../../../base/badge';
import Card from '../../../../base/card';
import Col from '../../../../base/col';
import Row from '../../../../base/row';

// Related Components
import Loading from './departments/loading';

export default class Departments extends React.Component {
  static propTypes = {
    user: PropTypes.object.isRequired,
    profile: PropTypes.object.isRequired,
    persona: PropTypes.object.isRequired,
  }

  state = {
    loading: true,
    selectedDepartments: [],
  }

  componentDidMount() {
    const { profile, persona } = this.props;
    if (isEmptyObject(persona) && (profile.department_ids || []).length > 0) {
      // For all personas
      Department
        .where({ id_in: profile.department_ids})
        .all(false)
        .then((selectedDepartments) => {
          this.setState({
            loading: false,
            selectedDepartments,
          })
        })
    } else if (!isEmptyObject(persona) && (persona.department_ids|| []).length > 0) {
      // For a specific persona
      Department
        .where({ id_in: persona.department_ids })
        .all(false)
        .then((selectedDepartments) => {
          this.setState({
            loading: false,
            selectedDepartments,
          })
        })
    } else {
      this.setState({
        loading: false,
        selectedDepartments: [],
      })
    }
  }

  render() {
    const { loading, selectedDepartments} = this.state;

    if (loading) {
      return <Loading />
    }

    return (
      <Card
        border='none'
        className='min-height-80'
        noPadding
      >
        <Row className='margin-top-15 margin-bottom-10' nested>
          <Col s={12} className='med-font dark margin-bottom-10'>
            Departments
          </Col>
          <Col s={12}>
            {
              selectedDepartments.map((department) => (
                <Badge
                  key={department.id}
                  text={department.name}
                />
              ))
            }
            {
              selectedDepartments.length === 0 &&
              <div className='gray-900'>None Selected</div>
            }
          </Col>
        </Row>
      </Card>
    )
  }
}